import { render, staticRenderFns } from "./meetings.vue?vue&type=template&id=45fbdfe3&scoped=true"
import script from "./meetings.vue?vue&type=script&lang=js"
export * from "./meetings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fbdfe3",
  null
  
)

export default component.exports